import { FC } from 'react';
import ReserveFrameSettingList from './ReserveFrameSettingList';
import UseReserveFrameSettingList from './UseReserveFrameSettingList';

const ReserveFrameSettingListContainer: FC = () => {
  return <ReserveFrameSettingList {...UseReserveFrameSettingList()} />;
};

export default ReserveFrameSettingListContainer;
